module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "kintro",
      "title": "Introduction"
    }
  }, [_c('p', {
    staticClass: "h2ai"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#krintro"
    }
  }, [_vm._v("introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('i', [_vm._v("i started HAND LETTERING just like anybody else did-DOODLING in the margins of my middle-school notebooks. i would write my name OVER & OVER in BLOCK, BUBBLE, and "), _c('b', [_vm._v("cursive")]), _vm._v(" letters. i moved onto other styles until i had a LIBRARY of letters")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bodytextt"
  }, [_c('i', [_vm._v("now, 15 years later, i bring a NOTEBOOK with me wherever i go. i find INSPIRATION everywhere-from an old sign to GRAFFITI on a wall to FLOWERS in cracks of pavement")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bodytextt"
  }, [_c('i', [_vm._v("i hope this book inspires the BOTANICAL LETTERER in you! it is designed to offer you a boost into the art of lettering through simple STEP-BY-STEP instructions. most of what i have learned is through IMITATION and repetition. PRACTICE, PRACTICE, PRACTICE! find something you like and keep drawing it until it becomes your own. REMEMBER, there are no mistakes in hand lettering-find BEAUTY in the IMPERFECTIONS. Use the prompts in this book to help your art FLOURISH and HAVE FUN!")])]), _vm._v(" "), _c('p', {
    staticClass: "righta"
  }, [_c('i', [_vm._v("- Bethany")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-588f6752","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Introduction.vue
// module id = 81
// module chunks = 0